import { render } from "./PerformancePage.vue?vue&type=template&id=b4c6993e&ts=true"
import script from "./PerformancePage.vue?vue&type=script&lang=ts"
export * from "./PerformancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__